import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "#0C723B",
  heroBackgroundEn: "white",
  heroBackgroundHe: "white",
  heroTextColor: "black",
  heroSvgIconColor: "#0B853A",
  filterModalHeaderColor: "rgba(12, 114, 59, 0.05)",
  filterModalHeaderTextColor: "#000",
  footerColor: "#0C723B",
  faqRootBackground: "white",
  faqRootInsideBackground: "white",
  faqRootInsideBackgroundHover: "white",
  faqRootInsideColorHover: "black",
  faqBorderColor: "#F7F7F7",
  faqTextColor: "#000",
  faqIconColor: "#009919",
  faqIconColorAlternative: "#000",
  faqBoxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08)",
  navBackgroundColor: "white",
  navTextColor: "black",
  selectedNavTextColor: "black",
  selectedSubNavTextColor: "black",
  selectedMobileNavTextColor: "black",
  footerSocialsBackgroundColor: "#0C723B",
  footerLogoLinkBackgroundColor: "transparent",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #009919 0%, #064021 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #064021 0%, #009919 100%)",
  numberGridBorderColor: "#0C723",
  newNumberGridTextColor: "rgba(12, 114, 60, 0.4)",
  accordionPanelBackgroundColor: "#064021",
  jobsQuoteGalleryBackgroundColor: "#0C723B",
  teamContainerBackgroundColor: "rgba(12, 114, 59, 1)",
  buttonHoverBackgroundColor: "#0C723B",
  buttonActiveBackgroundColor: "#0C723B",
  buttonDefaultBackgroundColor: "#0C723B",
  buttonSecondaryBorderColor: "#0C723B",
  buttonSecondaryFilledBackground: "rgba(6, 64, 33, 0.2)",
  buttonHoverTextColor: "white",
  paginationBackgroundColor: "#0C723",
  paginationTextColor: "white",
  bulletsBackgoundColor: "#0C723B",
  faqTextColorExpanded: "#009919",
  faqTextColorHover: "#009919",
  faqTitleBorderBottom: "#009919",
  jobCardTopHeader: "#000",
  heroBgFallback: "#0C723B",
}

export default colors
